/*
 * @Author: 丨小小风离丨
 * @Date: 2023-12-04 19:34:19
 * @LastEditTime: 2025-04-16 17:29:08
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\index.tsx
 * @Description: 
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/css/common_assembly.scss';
import '@/css/common_page.scss';
import 'lancoo-web-ui/style';
import 'element-theme-default';
import 'moment/locale/zh-cn';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { App as AppAnt } from "antd";


import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}> {/* 关闭降权操作，移除 :where() 选择器 */}
          {/* Ant Design 提供的包裹组件，用于使得 Message、Modal、Notification 等组件的静态调用形式能获取到上下文，从而读取移除 :where() 选择器的配置 */}
          <AppAnt style={{ width: '100%', height: '100%' }}>
            <App />
          </AppAnt>
        </StyleProvider>

      </PersistGate>
    </Provider>
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
